import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import config from "../../config";
import "./paymentprocessing.css";

const PaymentProcessingPage = () => {
  const navigate = useNavigate();
  const transactionID = useSelector((state) => state.payment.transactionID);
  const ApplicantID = useSelector((state) => state.auth.applicantId);
  const UserID = useSelector((state) => state.auth.userId);
  const [message, setMessage] = useState("Processing payment...");

  useEffect(() => {
    if (!transactionID) {
      window.alert("Transaction ID not found.");
      navigate("/profile");
      return;
    }

    const finalizePayment = async () => {
      try {
        const response = await axios.post(
          config.API_FINALIZE_PAYMENT_URL,
          { transactionID, UserID, ApplicantID },
          { headers: { "Content-Type": "application/json" } }
        );
        console.log("Finalize Payment Response:", response.data);

        if (response.data && response.data.ResponseCode === "0") {
          window.alert("Payment Successful.\nYour payment has been processed successfully.");
          navigate("/profile");
        } else {
          window.alert("Payment finalization failed: " + response.data.ResponseDescription);
          navigate("/profile");
        }
      } catch (error) {
        console.error("Finalize Payment Error:", error);
        window.alert("An error occurred while finalizing payment.");
        navigate("/profile");
      }
    };

    const timer = setTimeout(finalizePayment, 1000);
    return () => clearTimeout(timer);
  }, [transactionID, UserID, ApplicantID, navigate]);

  return (
    <div className="payment-processing-container">
      <div className="spinner"></div>
      <p>{message}</p>
    </div>
  );
};

export default PaymentProcessingPage;
